module.exports = __webpack_public_path__ + "media/images/ico-circle-minus-1a9ea75f.svg";